import { Err, err } from 'neverthrow'
import { isOfficeError } from '../utils/guards'
import {
  OfficeDialogUrlError,
  OfficeDisplayDialogAlreadyCloseError,
  OfficeDisplayDialogDeniedError,
  OfficeDisplayDialogError,
  OfficeDisplayDialogFailedToLoadPageError,
  OfficeDisplayDialogPopupBlockedError,
  OfficeDisplayDialogUnknownError,
  OfficeDisplayDialogUntrustedUrlError,
  OfficeDisplayDialogUntrustedUrlError2,
} from '../errors/dialog_errors'
import { OfficeActionError } from '../errors'

export const createOfficeDisplayDialogError = <T extends { code: number }>(
  error: T
): Err<never, OfficeActionError> => {
  switch (error.code) {
    case 12002:
      return err(new OfficeDisplayDialogFailedToLoadPageError())
    case 12003:
      return err(new OfficeDialogUrlError())
    case 12004:
      return err(new OfficeDisplayDialogUntrustedUrlError())
    case 12005:
      return err(new OfficeDisplayDialogUntrustedUrlError2())
    case 12006:
      return err(new OfficeDisplayDialogAlreadyCloseError())
    case 12007:
      return err(new OfficeDisplayDialogError())
    case 12009:
      return err(new OfficeDisplayDialogDeniedError())
    case 12011:
      return err(new OfficeDisplayDialogPopupBlockedError())
    default:
      return err(new OfficeDisplayDialogUnknownError())
  }
}

export const dialogErrorHandler = (error: unknown) => {
  return isOfficeError(error)
    ? createOfficeDisplayDialogError(error)
    : err(new OfficeDisplayDialogUnknownError())
}
